import React, {createContext} from 'react';

export const PageContext = createContext({
  cid:''
} as {
  cid:string
});
